// At least a 44 px tap target on touch screens, where a finger is less precise than a mouse.

/** Grows the element itself on touch screens. For buttons with room around them. */
export const TOUCH_MIN_H = "[@media(pointer:coarse)]:min-h-11";

/**
 * Grows only the hit area (an invisible ::before 12 px above and below), keeping the visual size. For small
 * pills and inline links where a taller element would break the layout.
 */
export const TOUCH_HIT_AREA =
    "relative [@media(pointer:coarse)]:before:absolute [@media(pointer:coarse)]:before:-inset-y-3 [@media(pointer:coarse)]:before:-inset-x-1 [@media(pointer:coarse)]:before:content-['']";
